<template>
    <div class="com-apply-warehouse">
        <step-header activeKey="3"></step-header>
        <div class="com-apply-warehouse__main">
            <div class="com-card-title">仓库地址信息</div>
            <div class="com-apply-warehouse__form com-form">
                <div :class="['com-form-item', {'is-error': error.full_name}]">
                    <label class="com-form__item-label">Name </label>
                    <input class="com-form__item-input" type="text" v-model="warehouse.full_name" @input="enter" />
                    <span class="com-form__item-explain" v-if="error.full_name">请输入Name</span>
                </div>
                <div :class="['com-form-item', {'is-error': error.email}]">
                    <label class="com-form__item-label">Email </label>
                    <input class="com-form__item-input" type="text" v-model="warehouse.email" @input="enter" />
                    <span class="com-form__item-explain" v-if="error.email">请输入Email</span>
                    <span class="com-form__item-explain" v-if="error.pattern">Email格式错误</span>
                </div>
                <div :class="['com-form-item', {'is-error': error.phone}]">
                    <label class="com-form__item-label">Phone </label>
                    <input class="com-form__item-input" type="text" v-model="warehouse.phone" @input="enter" />
                    <span class="com-form__item-explain" v-if="error.phone">请输入Phone</span>
                </div>
                <div :class="['com-form-item', {'is-error': error.city}]">
                    <label class="com-form__item-label">City </label>
                    <input class="com-form__item-input" type="text" v-model="warehouse.city" @input="enter" />
                    <span class="com-form__item-explain" v-if="error.city">请输入City</span>
                </div>
                <div :class="['com-form-item', {'is-error': error.address}]">
                    <label class="com-form__item-label">Address </label>
                    <input class="com-form__item-input" type="text" v-model="warehouse.address" @input="enter" />
                    <span class="com-form__item-explain" v-if="error.address">请输入Address</span>
                </div>
                <div :class="['com-form-item', {'is-error': error.post_code}]">
                    <label class="com-form__item-label">PostCode </label>
                    <input class="com-form__item-input" type="text" v-model="warehouse.post_code" @input="enter" />
                    <span class="com-form__item-explain" v-if="error.post_code">请输入PostCode</span>
                </div>
                <div class="com-form-item com-form-item--nolabel">
                    <button class="com-btn com-btn-submit" @click="back" style="margin-right: 10px;">上一步</button>
                    <button class="com-btn com-btn-primary com-btn-submit" @click="next"><i class="icon icon-loading" v-if="loading"/>提交</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import StepHeader from './step-header'
export default {
    name: 'apply-warehouse',
    components: {
        StepHeader,
    },
    data() {
        return {
            warehouse: {},
            error: {},
            loading: false
        }
    },
    created() {
        const params = JSON.parse(sessionStorage.getItem('params') || '{}');
        this.warehouse = params.warehouse || {};
    },
    methods: {
        enter() {
            if(this.warehouse.full_name) {
                this.$set(this.error, 'full_name', false)
            }
            if(this.warehouse.email) {
                this.$set(this.error, 'email', false)
            }
            if(this.warehouse.email && /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/g.test(this.warehouse.email)) {
                this.$set(this.error, 'pattern', false)
            }
            if(this.warehouse.phone) {
                this.$set(this.error, 'phone', false)
            } 
            if(this.warehouse.city) {
                this.$set(this.error, 'city', false)
            }
            if(this.warehouse.address) {
                this.$set(this.error, 'address', false)
            }
            if(this.warehouse.post_code) {
                this.$set(this.error, 'post_code', false)
            }
        },
        back() {
            this.$router.push({path: `/merchant/apply`, query: {s: 2}});
            this.$emit('end')
        },
        next() {
            if(!this.warehouse.full_name) {
                this.$set(this.error, 'full_name', true)
            }
            if(!this.warehouse.email) {
                this.$set(this.error, 'email', true)
            } 
            if(this.warehouse.email && !/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/g.test(this.warehouse.email)) {
                this.$set(this.error, 'pattern', true)
            }
            if(!this.warehouse.phone) {
                this.$set(this.error, 'phone', true)
            } 
            if(!this.warehouse.city) {
                this.$set(this.error, 'city', true)
            }
            if(!this.warehouse.address) {
                this.$set(this.error, 'address', true)
            }
            if(!this.warehouse.post_code) {
                this.$set(this.error, 'post_code', true)
            }
            if(this.warehouse.full_name && this.warehouse.email && this.warehouse.phone && this.warehouse.city && this.warehouse.address && this.warehouse.post_code) {
                const params = JSON.parse(sessionStorage.getItem('params') || '{}');
                params.warehouse = this.warehouse;
                sessionStorage.setItem('params', JSON.stringify(params))
                this.loading = true;
                this.$axios.post('/merchant/apply', params).then(res => {
                    this.loading = false;
                    if(res.data.meta.code === 0) {
                        sessionStorage.clear();
                        this.$router.push({path: `/merchant/apply`, query: {s: 4}});
                        sessionStorage.setItem('email', res.data.response.data)
                        this.$emit('end')
                    } else {
                        alert(res.data.meta.error)
                    }
                })
            }
        }
    }
}
</script>

<style lang="less" scoped>
    .com-apply-warehouse {
        &__form {
            margin-top: 30px;
        }
        .com-divider {
            margin: 40px 0 24px;
        }
        .com-btn-submit {
            width: 100px;
            border-radius: 20px;
            margin-top: 20px;
        }
    }
</style>

